import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";
import { View, Text, Card } from "../base";
import { Icon } from "../base/Icon";
import { ChartDataPoint, COLORS } from "../../utils/chartData";

interface VariantDistributionChartProps {
  data: ChartDataPoint[];
  title?: string;
}

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <View className="bg-white dark:bg-gray-800 p-3 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg">
        <Text className="font-medium">{data.name}</Text>
        <Text className="text-sm text-gray-600 dark:text-gray-400">Count: {data.value}</Text>
        {data.percentage && <Text className="text-sm text-gray-600 dark:text-gray-400">Percentage: {data.percentage}%</Text>}
      </View>
    );
  }
  return null;
};

export const VariantDistributionChart: React.FC<VariantDistributionChartProps> = ({ data, title = "Variant Distribution" }) => {
  if (!data || data.length === 0) {
    return (
      <Card>
        <View className="p-6">
          <View className="flex items-center mb-4">
            <Icon
              name="pie-chart"
              size={20}
              className="mr-2 text-blue-600 dark:text-blue-400"
            />
            <Text className="text-lg font-semibold">{title}</Text>
          </View>
          <View className="flex justify-center items-center h-64">
            <Text className="text-gray-500 dark:text-gray-400">No data available</Text>
          </View>
        </View>
      </Card>
    );
  }

  return (
    <Card>
      <View className="p-6">
        <View className="flex items-center mb-4">
          <Icon
            name="pie-chart"
            size={20}
            className="mr-2 text-blue-600 dark:text-blue-400"
          />
          <Text className="text-lg font-semibold">{title}</Text>
        </View>
        <ResponsiveContainer
          width="100%"
          height={300}
        >
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }) => `${name} ${((percent || 0) * 100).toFixed(0)}%`}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={entry.color || COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </View>
    </Card>
  );
};
